import { Tooltip } from '@lib/components'
import { Avatar } from '@octopus-do/octopus-storybook'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import type React from 'react'

import { chunk } from '@/utils/arrays'
import css from './styles.module.css'

type Props = {
  members: TeammateDto[]
}

const ROW_SIZE = 10

export const MembersList: React.FC<Props> = ({ members }) => {
  const rows = chunk(members, ROW_SIZE)

  return (
    <div className={css.members_list_container}>
      {rows.map((row, index) => (
        <div key={index} className={css.members_list_wrapper}>
          {row.map((member) => (
            <Tooltip
              key={member.id}
              content={member.name}
              className={css.members_list_tooltip}
              position="top"
            >
              <div className={css.members_list_item}>
                <Avatar
                  color={member.color}
                  name={member.name}
                  media={member.avatar}
                  size="sm"
                />
              </div>
            </Tooltip>
          ))}
        </div>
      ))}
    </div>
  )
}
